/**
 * Created by Administrador on 30/11/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('penaltiesCtrl', penaltiesCtrl)
        .controller('editPenaltyCtrl', editPenaltyCtrl);

    penaltiesCtrl.$inject = ['linkService','penalties'];
    editPenaltyCtrl.$inject = ['operationService','$stateParams','penalty'];

    function penaltiesCtrl(linkService,penalties){
        var vm = this;
        vm.linkService = linkService;
        vm.penalties = penalties;

    };

    function editPenaltyCtrl(operationService,$stateParams,penalty){
        var vm = this;

        vm.penalty = penalty.data;

        vm.savePenalty = function(isValid,penalty){
            if(isValid){
                operationService.updateOperation($stateParams.id,penalty)
            }
        }
    };
})();
